<nx-icon class="cursor-pointer" name={{iconName}} class="blueColor reduce-icon-size" (mouseover)='mouseOver()'
    (mouseout)='mouseOut()' [nxPopoverTriggerFor]="popoverBottomAnchor" nxPopoverDirection="bottom"
    nxPopoverTrigger="click" size="s">
</nx-icon>

<nx-popover #popoverBottomAnchor>
    <div [style.height]="height" [style.width]="width">{{infoMessage}} </div>
</nx-popover>